import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { useQuery } from 'react-query';
import DMSService from '../services/DMSService';

export function useTaxGroupQuery(deal: Deal, isEnabled: boolean) {
  return useQuery(
    ['dealer-tax-groups', deal.dealer_id],
    () => DMSService.getTaxGroups(deal.dealer_id!),
    {
      enabled: isEnabled,
    },
  );
}
